import React from 'react';
import { Pie } from 'react-chartjs-2';


function PieChart(props) {

    let lables = []
    let datasets = []
    let color = ['#147AD6', '#122D76', "#333333"]

    if (props.data) {
        if (props.type === "type") {
            props.data.forEach(element => {
                datasets.push(element.ValueCount)
                let key = `${element.ValueCount} ${element.Key}`
                lables.push(key)
                key = ""
            });

        } else {
            if (props.data.length > 0) {
                datasets = Object.values(props.data[0])
                let key = Object.keys(props.data[0])
                key.forEach((element, index) => {
                    let k = `${datasets[index]} ${element}`
                    lables.push(k)

                })
                color = ["#147AD6", "#FC4C02"]

            }
        }
    }


    const data = {
        labels: lables,
        datasets: [
            {
                data: datasets,
                backgroundColor: color
            },
        ],
    };
    const options = {
        responsive: true,
        maintainAspectRatio: false
    }

    return (
        <Pie data={data} options={options} />
    )
}

export default PieChart
